import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router, ActivatedRoute, Params} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {CustomsValidationDirective} from "../../../_directives/customs-validation.directive";
import {UserService} from "../../../_services/user.service";
import {Response} from "@angular/http";
import {Observable} from "rxjs/Observable";

@Component({
    selector: 'app-confirm-password',
    templateUrl: './confirm-password.component.html',
    styleUrls: ['../../register/register.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ConfirmPasswordComponent implements OnInit {

    public isResetPwDone: any = false;
    public isPwdReset: any;
    public loading: any = false;
    public changePasswordForgot: FormGroup;
    public msgErrPassConfirm: any = null;
    public uID: Observable<any>;
    private tokenPwd: any;
    public msgErrChangePassword: any = null;

    constructor(private userService: UserService,
                private router: Router,
                private formBuilder: FormBuilder,
                private activatedRoute: ActivatedRoute) {

        this.tokenPwd = this.activatedRoute.snapshot.paramMap.get('token_pwd');
        this.confirmPassword();
    }

    ngOnInit() {
        this.changePasswordForgot = this.formBuilder.group({
            password: new FormControl('', [Validators.required, this.noWhitespaceValidator, Validators.minLength(6)]),
            passConfirm: new FormControl('', [Validators.required])
        }, {
            validator: CustomsValidationDirective.MatchPassword
        });
    }

    confirmPassword() {
        let self = this;
        self.userService.confirmForgot({'token_pwd': self.tokenPwd})
            .subscribe((response: Response) => {
                let resData = response.json();
                if (resData.hasOwnProperty('result') && resData.result == false) {
                    if (resData.hasOwnProperty('type') && resData.type === '_FAIL_') {
                        self.isPwdReset = true;
                    }
                } else if (resData.hasOwnProperty('result') && resData.result == true) {
                    if (resData.hasOwnProperty('type') && (resData.type === '_OKM_')) {
                        self.isPwdReset = false;
                        self.isResetPwDone = false;
                        if (resData.hasOwnProperty('data')) {
                            self.uID = resData.data['uID'];
                        }
                    }
                }

                if (self.uID == undefined) {
                    self.isPwdReset = true;
                }
            }, error => {
                console.log(error);
            });
    }

    onChangePassword() {
        let self = this;
        if (this.changePasswordForgot.valid) {
            self.loading = true;
            let changePwdForgot = self.changePasswordForgot.value;
            changePwdForgot['uID'] = self.uID;
            changePwdForgot['token_pwd'] = self.tokenPwd;

            self.userService.changePwdForgot(changePwdForgot)
                .subscribe((data: Response) => {
                        self.loading = false;
                        try {
                            let resData = data.json();
                            if (resData.hasOwnProperty('result') && resData.result == false) {
                                if (resData.hasOwnProperty('type') && resData.type === '_VALIDATE_') {
                                    self.msgErrPassConfirm = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('passConfirm')) ? resData.error.passConfirm[0] : null;
                                    self.msgErrChangePassword = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('uID')) ? resData.error.uID[0] : null;
                                }
                            } else {
                                self.isResetPwDone = true;
                            }
                        } catch (e) {
                            console.log('error', e);
                        }
                    }
                );
        } else {
            CustomsValidationDirective.validateAllFormFields(self.changePasswordForgot);
        }
    }

    isFieldValid(field: string) {
        return !this.changePasswordForgot.get(field).valid && this.changePasswordForgot.get(field).touched;
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
            'has-feedback': this.isFieldValid(field)
        };
    }

    noWhitespaceValidator(control: FormControl) {
        return (control.value || '').indexOf(' ') >= 0 ? { 'whitespace': true } : null;
    }
}




// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/forgot/confirm-password/confirm-password.component.ts